import React from 'react'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../../../utils/anchorScroll'

const CashbackStatusButton = ({ translationStore, userStore, dropdownStore }) => {
  let inProgress = false

  if(userStore.transactions) {
    inProgress = userStore.transactions.filter(transaction => (transaction.status && (transaction.status==='forecast' || transaction.status==='payoff'))).length > 0
  }

  const onCashbackStatusButtonClick = () => {
    anchorScroll('top', '/wallet')
    dropdownStore.closeDropdown()
  }

  const inProcessCss = inProgress ? 'flex' : 'hidd'

  return (
    <span onClick={onCashbackStatusButtonClick} className='cursor-pointer'>
      <div className={`flex flex-row items-center ${inProcessCss} h-full`}>
        <img src='/img/cashback.svg' alt='CashbackStatus' className='h-12 min-w-16'/>
        <div className='hidd text-xs sm:block min-w-16'>
          <p className='font-bold text-grey-darkest'>{translationStore.translate('header_cashback').toUpperCase()}</p>
          <p className='font-bold text-red'>{translationStore.translate('header_in_progress').toUpperCase()}</p>
        </div>
      </div>
    </span>
  )
}

export default inject('translationStore','userStore', 'dropdownStore')(observer(CashbackStatusButton))



// WEBPACK FOOTER //
// ./src/components/Header/LoggedInHeader/CashbackStatusButton.js